import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';

import TrackTitle from './TrackTitle';
import ProgramCard from './ProgramCard';
import './Program.css';

export default class Program extends React.PureComponent {
    async componentDidMount() {
        window.scrollTo(0, 0);
        // await this.props.loadProgram();
    }

    onTrackSelect = event => {
        this.props.trackSelect(event.target.value);
    };

    onTalkClick = talkId => e => {
        if (talkId && e.target.id !== 'video-link') {
            this.props.pushAction(`/program/${talkId}`);
        }
    };

    renderProgramRow = (row, roomsInSlots) => {
        if (row.isBreak) {
            return (
                <div className="column program-break is-desktop is-full-touch">
                    <div className="column is-10-touch is-full-desktop">{row.timeslotName}</div>
                    <div className="column is-narrow is-hidden-desktop is-2 card-time">
                        {row.time}
                    </div>
                </div>
            );
        }
        const trackInSlot = {
            Innovations: 'slot1',
            Security: 'slot2',
            'Digital Transformation': 'slot3',
            Interfaces: 'slot4',
            Data: 'slot5',
            'Code & Talks': 'slot6'
        };
        const slots = Object.keys(row.statusOfTalks).sort();
        const filteredTracks =
            this.props.selectedTrack !== 'All'
                ? slots.filter(slot => slot === trackInSlot[this.props.selectedTrack])
                : slots;

        return filteredTracks.map(track => {
            const status = row.statusOfTalks[track];
            const talks = [];
            if (row.talks[track]) {
                row.talks[track].forEach(talkId => {
                    if (this.props.talksById[talkId]) {
                        talks.push(this.props.talksById[talkId]);
                    }
                });
            }
            const orderedTalks = orderBy(talks, ['order'], 'asc');
            const talk = orderedTalks[0] || {};
            const speakers = {};
            if (Object.keys(this.props.speakersById).length > 0 && orderedTalks[0]) {
                orderedTalks.forEach(item => {
                    speakers[item.id] = [];
                    item.speakers.forEach(speakerId => {
                        if (this.props.speakersById[speakerId]) {
                            speakers[item.id].push(this.props.speakersById[speakerId].name);
                        }
                    });
                });
            }
            let id = orderedTalks.length > 0 ? orderedTalks[0].id : '';
            if (
                status === 'KEYNOTE STREAM' &&
                row.talks.slot1.length > 0 &&
                this.props.talksById[row.talks.slot1[0]]
            ) {
                const keynote = { ...this.props.talksById[row.talks.slot1[0]] };
                // eslint-disable-next-line prefer-destructuring
                id = keynote.id;
            }
            return (
                <ProgramCard
                    id={id || ''}
                    key={track}
                    onClickHandler={this.onTalkClick}
                    room={talk.room || roomsInSlots[track] || ''}
                    screen="program"
                    speakers={speakers || {}}
                    talks={orderedTalks || []}
                    tileRole={status}
                    time={row.time}
                    track={track}
                />
            );
        });
    };

    renderProgram = () => {
        const timeslots = orderBy(Object.values(this.props.timeSlotsById), ['time'], ['asc']);
        const roomsInSlots = this.findRoomPerTrack();
        return timeslots.map(slot => (
            <div className="columns is-variable is-mobile is-multiline is-1" key={slot.time}>
                <div className="column is-1-desktop is-hidden-touch time-box">{slot.time}</div>
                {this.renderProgramRow(slot, roomsInSlots)}
            </div>
        ));
    };

    findRoomPerTrack = () => {
        const { talksById } = this.props;
        // preserve correct order of tracks
        const trackInSlot = {
            Innovations: '',
            Security: '',
            'Digital Transformation': '',
            Interfaces: '',
            Data: '',
            'Lightning Talk': '',
            'Live Coding Session': '',
            'Hands-on Lab': ''
        };

        Object.keys(talksById).forEach(talkId => {
            const talkData = talksById[talkId];
            if (talkData.track && trackInSlot[talkData.track].length === 0 && talkData.room) {
                trackInSlot[talkData.track] = talkData.room;
            }
        });

        const roomsInSlots = {
            slot1: trackInSlot.Innovations || '',
            slot2: trackInSlot.Security || '',
            slot3: trackInSlot['Digital Transformation'] || '',
            slot4: trackInSlot.Interfaces || '',
            slot5: trackInSlot.Data || '',
            slot6: trackInSlot['Lightning Talk'] || trackInSlot['Live Coding Session'] || ''
        };

        return roomsInSlots;
    };

    render() {
        return (
            <section className="section" id="program-section">
                <div className="container">
                    <div className="columns is-multiline is-vcentered page-title-row">
                        <div className="column" />
                        <h1 className="column">PROGRAM</h1>
                        <span className="column program-date">
                            <i className="fas fa-calendar-alt" /> Friday, October, 18
                        </span>
                    </div>
                    <div className="columns is-variable is-desktop is-hidden-mobile is-hidden-touch is-1">
                        <div className="column is-1-desktop" />
                        <TrackTitle title="Innovations" trackColor="track1-color" />
                        <TrackTitle title="Security" trackColor="track2-color" />
                        <TrackTitle title="Digital Transformation" trackColor="track3-color" />
                        <TrackTitle title="Interfaces" trackColor="track4-color" />
                        <TrackTitle title="Data" trackColor="track5-color" />
                        <TrackTitle title="Code & Talks" trackColor="track6-color" />
                    </div>
                    <div className="field is-hidden-desktop ">
                        <label className="label" htmlFor="program-header">
                            SELECT STREAM
                        </label>
                        <div className="control" id="program-header">
                            <div className="select is-medium track-select">
                                <select
                                    onChange={this.onTrackSelect}
                                    value={this.props.selectedTrack}
                                >
                                    <option>All</option>
                                    <option>Innovations</option>
                                    <option>Security</option>
                                    <option>Digital Transformation</option>
                                    <option>Interfaces</option>
                                    <option>Data</option>
                                    <option>Code & Talks</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {!this.props.fetchingProgram ? (
                        this.renderProgram()
                    ) : (
                        <i
                            className="fa fa-spinner fa-spin fa-3x fa-fw"
                            style={{ color: '#7500c0' }}
                        />
                    )}
                </div>
            </section>
        );
    }
}

Program.propTypes = {
    fetchingProgram: PropTypes.bool.isRequired,
    pushAction: PropTypes.func.isRequired,
    selectedTrack: PropTypes.string.isRequired,
    speakersById: PropTypes.objectOf(PropTypes.any).isRequired,
    talksById: PropTypes.objectOf(PropTypes.any).isRequired,
    timeSlotsById: PropTypes.objectOf(PropTypes.any).isRequired,
    trackSelect: PropTypes.func.isRequired
};
